<h1>CIFRIS25 - Third National Conference</h1>
<div class="toptext">
	<p>
		CIFRIS25 is an international event, supported and organized by De Cifris and Roma Tre University, with the precious cooperation of Agenzia per la Cybersicurezza Nazionale (ACN).<br><br>CIFRIS25  aims at bringing together
		researchers in the field of cryptography, practitioners, developers, and users to foster cooperation and
		exchange techniques, tools, experiences, and ideas.
	</p>
	<p>
		The first morning is reserved to institutional and industrial stakeholders operating in the field of
		cryptography and cyber security. The first afternoon constitute the Scientific
		Session of the event, where scientific talks take place. The second day hosts  related workshops.
	</p>
	<p>
		Scientific talks consist of a selection of:
	</p>
	<ul>
		<li> One invited talk and </li>
		<li> Scientific talks selected by the Organizing Committee. </li>
	</ul>
</div>

<!-------------------------------------------------------------------->

<h2> INVITED SPEAKER </h2>

  <div class="text"  style="text-align:center;font-size: 20px;">
  	<b>Ludovic Perret</b> ( Sorbonne University & EPITA - France)
</div>

<!-------------------------------------------------------------------->

<h2> ORGANIZATION </h2>
<div class="text">
	<h3> Institution </h3>
	<p>
		The “De Componendis Cifris Associazione di Promozione Sociale” (<a href="./">De Cifris</a>) is a non-profit
		scientific
		organization whose purpose is to spread cryptography in all its aspects, from theoretical foundations,
		applications to historical evolution and impact on society, and to facilitate the aggregation of scholars
		and researchers, so that from their collaboration project ideas and initiatives of scientific interest can
		rise.
	</p>

	<h3> Organizing Committee </h3>
	<ul>
		<li>
		        Laura Capuano (Roma Tre University - Italy)
		</li>
		<li>
		        Roberto Civino (University of L'Aquila - Italy)
		</li>
		<li>
			Francesco Romeo (University of Cassino and Southern Lazio - Italy)
		</li>
		<li>
			Giordano Santilli (National Cybersecurity Agency - Italy)
		</li>
	</ul>
	<b> Events Coordinator:</b> Elisa Cermignani (Athilab Srl - De Cifris) <br> <br>
	For further information contact us at <a href="mailto:cifris25@decifris.it">cifris25<span>&#64;</span>decifris.it</a>
</div>
